import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
      },
      telNumber: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
          { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
        ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    Category: {
        validations: []
      },
      SiteName: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' },
          ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
      },
      Reference: {
        validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
            {
          type: 'text',
          size: 'Medium',
          label: 'Phone Number:*',
          mapping: 'telNumber'
        }
      ]
    },
    {
      fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Your Corporate Event Type:',
            options: [
              { label: 'Staff Party', value: 'Staff Party' },
              { label: 'Team Building Event', value: 'Team Building Event' },
              { label: 'Exhibition Stand', value: 'Exhibition Stand' },
              { label: 'Product Launch', value: 'Product Launch' },
              { label: 'Client Evening', value: 'Client Evening' },
              { label: 'Not Sure, Help!', value: 'Not Sure, Help!' },
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
            {
          type: 'text',
          size: 'Medium',
          label: 'Event Location:*',
          mapping: 'SiteName'
      }
  ]
  },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests (Min of 18 guests):*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Mix & Twist Catering Contact Form',
    formId: '1898',
    clientKey: '61DD48FE-8037-4CA9-B1D1-7F87BFFBE1D1',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.mixandtwist.co.uk/ty-enquiry',
    submissionText: 'Thank you! Your enquiry has been successfully sent and we will be in touch shortly to start building a great event with you.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
